import { NavigationItem } from "@/types/longhouseTypes";

export const navigationData: NavigationItem[] = [
    {
        name: "Dashboard",
        href: "",
        icon: "home-outline",
        children: [],
    },
    {
        name: "Players",
        href: "/longhouse/players",
        icon: "fi-user",
        children: [],
    },
    {
        name: "Upload Shields",
        href: "/longhouse/upload-shields",
        icon: "gi-viking-shield",
        children: [],
    },
    {
        name: "Upload Player Avatars",
        href: "/longhouse/upload-avatars",
        icon: "fi-user",
        children: [],
    },
    {
        name: "Upload Hype Prizes",
        href: "/longhouse/upload-hype-prizes",
        icon: "lucide-gift",
        children: [],
    },
    {
        name: "Upload Tag Images",
        href: "/longhouse/tag-images",
        icon: "gi-viking-shield",
        children: [],
    },
    {
        name: "Upload Wallhalla",
        href: "/longhouse/upload-wallhalla",
        icon: "gi-viking-shield",
        children: [],
    },
    {
        name: "Stream Team",
        href: "/longhouse/stream-team",
        icon: "lucide-users",
        children: [],
    },
    {
        name: "Vanderwood Streams",
        href: "/longhouse/vanderwood-streams",
        icon: "lucide-signal",
        children: [],
    },
    {
        name: "Shield Mates",
        href: "/longhouse/shield-mates",
        icon: "gi-viking-shield",
        children: [],
    },
    {
        name: "Messaging",
        href: "/longhouse/messaging",
        icon: "lucide-mail",
        children: [],
    },
    {
        name: "Admin User API",
        href: "/longhouse/admin-user-api",
        icon: "lucide-key-round",
        children: [],
    },
    {
        name: "Feature Flags",
        href: "/longhouse/feature-flags",
        icon: "cog-6-tooth-outline",
        children: [],
    },
    {
        name: "Twitch Connections",
        href: "/longhouse/twitch-connections",
        icon: "lucide-key-round",
        children: [],
    },
    {
        name: "Stream Deck",
        href: "/longhouse/stream-deck",
        icon: "stream-deck",
        children: [],
    },
    {
        name: "Season Management",
        href: "/longhouse/season-management",
        icon: "season-calendar",
        children: [],
    },
    {
        name: "Tag History",
        href: "/longhouse/tag-history",
        icon: "gi-viking-shield",
        children: [],
    },
    {
        name: "Chat Logs",
        href: "/longhouse/chat-logs",
        icon: "lucide-clipboard-list",
        children: [],
    },
    {
        name: "Background Tasks",
        href: "/longhouse/background-tasks",
        icon: "lucide-clipboard-list",
        children: [],
    },
    {
        name: "Exalted Reforge",
        href: "/longhouse/exalted-reforge",
        icon: "gi-viking-shield",
        children: [],
    },
    {
        name: "Stream Settings",
        href: "/longhouse/stream-settings",
        icon: "cog-6-tooth-outline",
        children: [],
    },
    {
        name: "Surveys",
        href: "/longhouse/surveys",
        icon: "lucide-clipboard-list",
        children: [],
    },
    {
        name: "Development",
        href: "",
        icon: "lucide-code",
        children: [
            {
                name: "Webhooks",
                href: "/longhouse/webhooks",
            },
        ],
    },
];
